import React from 'react';
import { connect } from 'react-redux';
import { Dimensions } from 'react-native';
import { withNavigationFocus } from 'react-navigation';

import withAuth from 'common/hoc/withAuth';

import login from 'modules/general/shared/action/login';
import isUserLoggedIn from 'modules/general/shared/utils/isUserLoggedIn';
import { FAILED_AUTHENTICATION } from '../constants/loginCallbackMessageType';
import ErrorResponseScreen from 'common/components/ErrorResponseScreen/ErrorResponseScreen';

const mapStateToProps = state => ({
  authState: state.general.auth,
});

const mapDispatchToProps = dispatch => ({
  login: authResult => dispatch(login(authResult)),
});

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

@connectToRedux
@withAuth
@withNavigationFocus
export default class LoginScreen extends React.Component {
  state = {
    key: 0,
  };

  checkLogin = () => {
    const { navigation, authState } = this.props;

    if (isUserLoggedIn(authState)) {
      navigation.push('Home');
    }
  };

  retryLogin = () => {
    this.props.navigation.setParams({ unauthorized: undefined });
  };

  componentDidMount() {
    this.checkLogin();
    window.addEventListener('message', this.handleCallbackAuthentication);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleCallbackAuthentication);
  }

  handleCallbackAuthentication = event => {
    try {
      const data = JSON.parse(event.data);

      if (data.type === FAILED_AUTHENTICATION) {
        // change iframe key to re-render the iframe, brings back user
        // to login page
        // TODO (yusei) show error message and button to retry login
        this.setState({ key: this.state.key + 1 });
        return;
      }

      if (data.accessToken && data.idToken && data.expiresIn) {
        this.props.login(data);
        // won't work with navigation.push()
        this.props.navigation.push('Home');
      }
    } catch (err) {
      // event is not related to `login - callback` communication
    }
  };

  static navigationOptions = {
    header: null,
  };

  render() {
    const { auth, navigation, isFocused } = this.props;
    const { height, width } = Dimensions.get('window');

    if (!isFocused) {
      return null;
    }

    const unauthorizedError = Boolean(
      navigation.getParam('unauthorized', false)
    );

    if (unauthorizedError) {
      return (
        <ErrorResponseScreen
          error={{
            title: 'Tidak memiliki izin',
            message:
              'Akun anda tidak memiliki izin untuk menggunakan aplikasi TOS. Silahkan hubungi admin anda untuk menambahkan izin pada akun anda',
            ctaButtonLabel: 'Coba login ulang',
            onClickCtaButton: this.retryLogin,
          }}
        />
      );
    }

    return (
      <iframe
        src={auth.getAuthorizeUrl()}
        title="Login screen"
        frameBorder="0"
        width={width}
        height={height}
        key={this.state.key}
      />
    );
  }
}
